import React from 'react'

const statusColors = {
  draft:     '#3454c1',
  published: '#1f5e3a',
  archived:  '#666',
  stale:     '#c66a45',
}

export default function DFBadge({ status = 'draft', label }) {
  const color = statusColors[status] || statusColors.draft

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        fontWeight: 500,
        color: 'var(--df-ink-2)',
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: color,
          flexShrink: 0,
        }}
      />
      {label && <span>{label}</span>}
    </span>
  )
}
